import { Dispatch, SetStateAction } from "react";
import { ThreeDPQuizResultsType } from "@WahooFitness/cloud-client-types";
import QuizContainer from "../QuizContainer";
import ThreeDPQuiz from "./ThreeDPQuiz";

function ThreeDPQuizContainer({
  setResults,
  setError,
  setPage,
  skipEducation,
  onFirstStepBack,
}: {
  setResults: Dispatch<SetStateAction<ThreeDPQuizResultsType | undefined>>;
  setError: Dispatch<SetStateAction<string | undefined>>;
  setPage: Dispatch<SetStateAction<number>>;
  skipEducation: boolean;
  onFirstStepBack?: () => void;
}) {
  return (
    <QuizContainer
      renderQuiz={(user) => (
        <ThreeDPQuiz
          user={user}
          setError={setError}
          setResults={setResults}
          setPage={setPage}
          skipEducation={skipEducation}
          onFirstStepBack={onFirstStepBack}
        />
      )}
    />
  );
}

export default ThreeDPQuizContainer;
